import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, LoadingController, AlertController, ToastController } from 'ionic-angular';
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl
} from "@angular/forms";
import { DatabaseProvider } from '../../providers/database/database';
import { AppConfig } from "../../providers/config";
import { AuthProvider } from '../../providers/auth/auth';
import { Subject } from 'rxjs';

@IonicPage()
@Component({
  selector: 'page-admin-clinics-add',
  templateUrl: 'admin-clinics-add.html',
})
export class AdminClinicsAddPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  user: any;

  clinic: any;
  clinicdata: any = {};
  clinicForm: FormGroup;
  clinic_name: FormControl
  phone_number: FormControl;
  address: FormControl;
  address2: FormControl;
  city: FormControl;
  province: FormControl;
  postal_code: FormControl;
  cutoff_day: FormControl;
  cutoff_time: FormControl;
  provinces: any;

  isExisting: boolean = false;
  clinic_id: any = null;
  operation_type: any = 'Add Clinic';

  locations: any[] = [];
  suppliesList: any = [];
  category_previous: string;

  constructor(
    public viewCtrl: ViewController, 
    public navCtrl: NavController, 
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    private database: DatabaseProvider,
    public loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private auth: AuthProvider
    ) {
      this.auth.getCurrentUser().then(user => {
        this.user = user;
      });
    
    this.provinces = AppConfig.Global.provinces;

    this.clinic_name = new FormControl(
      "",
      Validators.compose([
        Validators.maxLength(50),
        Validators.pattern("[a-zA-Z -]*"),
        Validators.required
      ])
    );
    this.phone_number = new FormControl("");

    this.address = new FormControl("", Validators.required);
    this.address2 = new FormControl("");
    this.city = new FormControl("", Validators.required);
    this.province = new FormControl("", Validators.required);
    this.postal_code = new FormControl("", Validators.required);
    this.cutoff_day = new FormControl("");
    this.cutoff_time = new FormControl("");

    this.clinic = formBuilder.group({
      clinic_name: this.clinic_name,
      phone_number: this.phone_number,
      address: this.address,
      address2: this.address2,
      city: this.city,
      province: this.province,
      postal_code: this.postal_code,
      cutoff_day: this.cutoff_day,
      cutoff_time: this.cutoff_time
    });

    if (this.navParams.get('clinicdata')) {
      const clinic: any = this.navParams.get('clinicdata');
      this.clinic_id = clinic.id;
      this.clinicdata['clinic_name'] = clinic['clinic_name'];
      this.clinicdata['phone_number'] = clinic['phone_number'];
      this.clinicdata['address'] = clinic['address']['address'];
      this.clinicdata['address2'] = clinic['address']['address2'];
      this.clinicdata['city'] = clinic['address']['city'];
      this.clinicdata['province'] = clinic['address']['province'];
      this.clinicdata['postal_code'] = clinic['address']['postal_code'];
      this.clinicdata['cutoff_day'] = clinic['cutoff_day'];
      this.clinicdata['cutoff_time'] = clinic['cutoff_time'];
      this.clinic.patchValue(this.clinicdata);

      if(clinic['locations']) {
        this.locations = clinic['locations']
      }
      
      this.isExisting = true;
      this.operation_type = "Edit " + this.clinicdata.clinic_name;

      this.database
      .getSupplies()
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          if(a.payload.doc.data()['clinics']) {
            data.default = (a.payload.doc.data()['clinics'].includes(this.clinic_id));
            // data.default = (a.payload.doc.data()['clinics_default'].includes(this.clinic_id));
          }
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((supplies) => {
        this.suppliesList = supplies;
      });
    }
  }

  ngOnDestroy() {
    console.log('Leave clinic add edit view and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  locationAddEdit(location) {
    let updatelocation: any = {name: null, address: null, city: null, phone_number: null};
    if(location)  {
      updatelocation.name = location.name;
      updatelocation.address = location.address;
      updatelocation.city = location.city;
      updatelocation.phone_number = location.phone_number;
    }
    const prompt = this.alertCtrl.create({
      title: 'Add Location',
      message: 'Enter location information',
      inputs: [
        {
          name: 'name',
          placeholder: 'Name of Location',
          value: updatelocation.name
        },
        {
          name: 'address',
          placeholder: 'Street No and Name',
          value: updatelocation.address
        },
        {
          name: 'city',
          placeholder: 'City',
          value: updatelocation.city
        }, 
        {
          name: 'phone_number',
          placeholder: 'Phone Number',
          value: updatelocation.phone_number
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {}
        },
        {
          text: 'Save',
          handler: data => {
            let newlocation: any = {};
            newlocation.name = data.name;
            newlocation.address = data.address;
            newlocation.city = data.city;
            newlocation.phone_number = data.phone_number;

            // Mandatory Field Check
            console.log(this.clinic_name);
            if (newlocation.name === null || newlocation.name === '' || newlocation.name === this.clinic_name.value
              || this.locations.map(l => l.name).indexOf(newlocation.name) > -1
              || newlocation.address === null || newlocation.address === '')  {
              const toast = this.toastCtrl.create({
                message: 'Invalid location information',
                duration: 3000
                });
                toast.present();
                return false;
            } else {
              if(!location) {
                this.locations.push(newlocation);
              } else {
                let index = this.locations.indexOf(location);
                this.locations[index] = newlocation;
              }
            }
          }
        }
      ]
    });
    prompt.present();
  }

  removeLocation(location)  {
    let index = this.locations.indexOf(location);
    if (index > -1) {
      this.locations.splice(index, 1);
    }
  }

  addClinic()  {
    let clinic = this.clinic.value;

    let newClinic: any = {};
    newClinic.clinic_name = clinic.clinic_name;
    newClinic.phone_number = clinic.phone_number;

    newClinic.address = {};
    newClinic.address.address = clinic.address;
    newClinic.address.address2 = clinic.address2;
    newClinic.address.city = clinic.city;
    newClinic.address.province = clinic.province;
    newClinic.address.postal_code = clinic.postal_code;
    newClinic.current_order = 0;
    newClinic.cutoff_day = clinic.cutoff_day;
    newClinic.cutoff_time = clinic.cutoff_time;

    newClinic.locations = []
    if(this.locations.length > 0) {
      newClinic.locations = this.locations;
    }
    const loader = this.loadingCtrl.create({});

    loader.present()
    this.database.createClinic(newClinic, this.user).then(_ => {
      loader.dismiss().then(() => {
        this.dismiss();
      })
    })
    .catch((err) => {
      loader.dismiss();
    })
  }

  updateClinic()  {
    let clinic = this.clinic.value;

    let updateClinic: any = {};
    updateClinic.clinic_name = clinic.clinic_name;
    updateClinic.phone_number = clinic.phone_number;

    updateClinic.address = {};
    updateClinic.address.address = clinic.address;
    updateClinic.address.address2 = clinic.address2;
    updateClinic.address.city = clinic.city;
    updateClinic.address.province = clinic.province;
    updateClinic.address.postal_code = clinic.postal_code;
    updateClinic.cutoff_day = clinic.cutoff_day;
    updateClinic.cutoff_time = clinic.cutoff_time;

    updateClinic.locations = [];
    if(this.locations.length > 0) {
      updateClinic.locations = this.locations;
    }
    const loader = this.loadingCtrl.create({});

    console.log(updateClinic.locations);
    if (updateClinic.locations.map(l => l.name).indexOf(updateClinic.clinic_name) > -1) {
      const toast = this.toastCtrl.create({
        message: 'Location name must not be the same as clinic name',
        duration: 3000
      });
      toast.present();
    } else {
      loader.present()
      this.database.updateClinic(this.clinic_id, updateClinic, this.user).then(_ => {
        loader.dismiss().then(() => {
          this.dismiss();
        })
      })
        .catch((err) => {
          loader.dismiss();
        })
    }
  }

  showDivider(category: string) {
    if (category !== this.category_previous) {
      this.category_previous = category;
      return true;
    } else {
      this.category_previous = category;
      return false;
    }
    
  }

  checkToggled(clinics) {
    if(clinics) {
      return (clinics.includes(this.clinic_id));
    } else {
      return false;
    }
  }

  updateSuppliesClinic(ev, supply) {
    if (ev.value) {
      if(supply.clinics) {
        supply.clinics.push(this.clinic_id);
      }
      else {
        supply['clinics'] = [];
        supply.clinics.push(this.clinic_id);
      }
    } else {
      if(supply.clinics)  {
        const index: number = supply.clinics.indexOf(this.clinic_id, 0);
        if (index > -1) {
          supply.clinics.splice(index, 1);
       }
      }
      if(supply.clinics_default)  {
        const index: number = supply.clinics_default.indexOf(this.clinic_id, 0);
        if (index > -1) {
          supply.clinics_default.splice(index, 1);
        }
      }
    }
    this.database.updateSupply(supply)
    .then(()=>{})
    .catch((err) => {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-clinics-add/admin-clinics-add.ts